import React from 'react';
import './Awards.css';

// Step 1: Import the images from your src/assets folder.
// Webpack will handle the pathing for you.
import cispImage from '../assets/cisp.PNG';
import isoImage from '../assets/iso.PNG';
import ciscoImage from '../assets/cisco.PNG';

// Step 2: Use the imported variables in your data array.
const certificationsData = [
  {
    title: 'Certified Information Systems Security Professional (CISSP)',
    issuer: 'Issued by: (ISC)² / ANAB',
    description: 'A globally recognized, vendor-neutral credential that validates an elite level of cybersecurity expertise. It demonstrates the ability to design, implement, and manage a best-in-class cybersecurity program.',
    image: cispImage // Use the imported variable here
  },
  {
    title: 'ISO/IEC 27001:2022 Lead Auditor',
    issuer: 'Issued by: Mastermind Assurance',
    description: 'Certifies the expertise required to audit an Information Security Management System (ISMS). This ensures an organization\'s data is protected through robust compliance and risk management practices.',
    image: isoImage // Use the imported variable here
  },
  {
    title: 'Cisco Certified Specialist – Security Core',
    issuer: 'Issued by: Cisco',
    description: 'Validates advanced skills in core security technologies for professional-level roles. It demonstrates expertise in implementing and operating Cisco security solutions, including network, cloud, and content security.',
    image: ciscoImage // Use the imported variable here
  }
];

const Awards = () => {
  return (
    <section className="certifications-section">
      <div className="certifications-container">
        <div className="certifications-header">
          <h2>A Commitment to Excellence from Our CEO</h2>
          <p>
            Our CEO’s personal achievements and professional accreditations demonstrate a strong commitment to expertise, security, and compliance best practices, setting a high standard for our organization.
          </p>
        </div>
        <div className="certifications-grid">
          {certificationsData.map((cert, index) => (
            <div className="certification-card" key={index}>
              <div className="cert-image-wrapper">
                {/* The img tag now uses the variable path provided by the import */}
                <img src={cert.image} alt={`${cert.title} Certificate`} className="cert-image" />
              </div>
              <div className="cert-details">
                <h3 className="cert-title">{cert.title}</h3>
                <p className="cert-issuer">{cert.issuer}</p>
                <p className="cert-description">{cert.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Awards;